import Axios from "axios";

import { env } from "@blueskydataplatform/shared-ui/config/env";

/**
 * Probe client for the (optional) console session, used on the login page to detect an already
 * signed-in user. A 401 is a normal "not signed in" result — accepted as a valid status — so this
 * client, unlike `authApiWithAuth`, has NO response interceptor: it never redirects to login and
 * never toasts (which would loop on the login page). Same-origin request; the `cloud-sid` cookie is
 * sent automatically.
 */
export const sessionApi = Axios.create({
  baseURL: env.API_URL_V2,
  validateStatus: (status: number) => (status >= 200 && status < 300) || status === 401,
});
